import type { AttendanceDay } from "../types";

/**
 * Domen «kun to'liq ma'lumot ustida hisoblanmagan» degani uchun ishlatadigan
 * buzilish turi (`packages/domain/src/attendance.ts`).
 */
export const TOLIQSIZ_MALUMOT = "toliqsiz_malumot";

/**
 * Kun DASTLABKImi (spec §6.4).
 *
 * ⚠️⚠️ **Mezon UI'da QAYTA HISOBLANMAYDI — u javobdan o'qiladi.**
 * Ilgari bu funksiya `computedFromWatermark` ni `dayjs(workDate).endOf("day")`
 * bilan solishtirardi va bu IKKI sababdan noto'g'ri edi:
 *
 * 1. **Kanonik mezon boshqa.** `projectAttendanceDay` watermark'ni kalendar
 *    kun oxiri bilan emas, kun OYNASINING oxiri bilan solishtiradi
 *    (`oynaOxiri` = oxirgi `check_out`, u bo'lmasa `min(now, plannedEndAt)`).
 *    Tungi smenada ikkalasi qarama-qarshi javob berardi: 21.08 22:00 → 22.08
 *    06:00 smenasida watermark 22.08 01:00 bo'lsa domen kunni DASTLABKI deb
 *    belgilaydi, kalendar mezoni esa «to'liq» deb ko'rsatardi — FAIL-OPEN.
 *    Teskari yo'nalish ham bor: watermark odatda yarim tundan oldin
 *    to'xtagani uchun TO'LIQ hisoblangan deyarli har qator belgi olardi va
 *    belgi ma'nosini yo'qotardi.
 * 2. **`endOf("day")` BRAUZER vaqt zonasida ishlaydi**, `settings.timezone`
 *    esa frontendda umuman o'qilmaydi — bitta sozlamadan ikki iste'molchi
 *    farqli «bugun» oladigan sinf (CLAUDE.md).
 *
 * Domen shu qarorni allaqachon qabul qilgan va uni `violations` ga
 * `toliqsiz_malumot` sifatida yozgan; javob (`toDayResponse`) uni ham
 * ro'yxatda, ham tafsilotda TO'LIQ uzatadi. Shuning uchun yagona to'g'ri
 * o'qish — shu buzilishning borligi.
 */
export function isPreliminary(day: Pick<AttendanceDay, "violations">): boolean {
	return day.violations.some((violation) => violation.kind === TOLIQSIZ_MALUMOT);
}
